import { CommandType } from "../../../../common/services/cqs/CommandType";
import { VKAtgardLeveransvirkesvolymDTO } from "../../models/atgard-leveransvirkesvolym-models";
import { AtgardLeveransvirkesVolymCommandBase } from "./AtgardLeveransvirkesVolymCommandBase";

export class RemoveAtgardLeveransvirkesVolymCommand extends AtgardLeveransvirkesVolymCommandBase {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "RemoveAtgardLeveransvirkesVolymCommand";

    constructor(leveransvirkesvolym: VKAtgardLeveransvirkesvolymDTO, kontraktGuid: string) {
        super(leveransvirkesvolym, RemoveAtgardLeveransvirkesVolymCommand.$type, CommandType.Delete);
        this.kontraktGuid = kontraktGuid;
    }
}
